import { useState, useEffect } from 'react';
import generateGlobalSearchAutocompleteChildren from '../Components/Molecules/GlobalSearchDynamic/generateGlobalSearchAutocompleteChildren';
import { initIndex } from '../Callbacks/algoliaHelper/searchClient';
import getAlgoliaSuggestionIndex from '../utils/getAlgoliaSuggestionIndex';
import {
  createLocalizationAlgoliaQuery,
  createLocalizedAlgoliaDocsQuery,
  createCanadaEcomedesAlgoliaQuery,
} from '../utils/handleLocalization';
import { formatFilters } from '../utils/algoliaFiltrationHelper';
import replaceSearchQuerySeparators from '../utils/replaceSearchQuerySeparators';

const { server } = window?.drupalSettings?.sgnaGeolocation?.siteLocale;
const defaultIndex = `${server}_sgna_global_search`;
const index = initIndex(defaultIndex);
const suggestionIndex = initIndex(getAlgoliaSuggestionIndex(defaultIndex));

const useGlobalSearchAutocompleteValues = ({
  searchTerm,
  debouncedSearchTerm,
}) => {
  const searchTextValue =
    searchTerm?.globalSearch || searchTerm?.queryValue || '';
  const [searchResultsList, setSearchResultsList] = useState({});

  const defaultRequestParams = {
    page: 0,
    hitsPerPage: 3,
  };

  const searchRequest = (searchIndex, requestOptions) => {
    return searchIndex.search(
      replaceSearchQuerySeparators(searchTextValue),
      requestOptions,
    );
  };

  function search() {
    if (!searchTextValue) {
      setSearchResultsList({});
      return;
    }

    Promise.all([
      searchRequest(suggestionIndex, {
        ...defaultRequestParams,
        clickAnalytics: true,
        attributesToRetrieve: [
          '_highlightResult',
          'media_field_name',
          'media_name',
          'query',
          defaultIndex,
        ],
      }),
      searchRequest(index, {
        ...defaultRequestParams,
        facetFilters: [['sgna_bundle_label:Products']],
        filters: createLocalizationAlgoliaQuery(),
        attributesToRetrieve: [
          'field_is_specialty_ceiling',
          'product_color_chips',
          'product_color_swatches',
          'field_image',
          'field_product_category',
          'product_new_tag',
          'url',
          'title',
          'nid',
        ],
      }),
      searchRequest(index, {
        ...defaultRequestParams,
        facetFilters: [['sgna_bundle_label:Documents & downloads']],
        filters: formatFilters([
          createLocalizedAlgoliaDocsQuery(),
          createCanadaEcomedesAlgoliaQuery(),
        ]),
        attributesToRetrieve: [
          'media_field_name',
          'media_name',
          'second_eyebrow',
          'media_field_region_top_abbreviation',
          'media_field_language_abbreviation',
          'sgna_media_download_url',
          'mid',
        ],
      }),
    ]).then(([suggestions, products, documents]) => {
      setSearchResultsList({
        suggestions,
        products,
        documents,
      });
    });
  }

  useEffect(() => {
    if (debouncedSearchTerm) {
      search();
    }
  }, [debouncedSearchTerm]);

  return generateGlobalSearchAutocompleteChildren({
    ...searchResultsList,
    searchTerm,
    defaultIndex,
  });
};

export default useGlobalSearchAutocompleteValues;
